import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import api from 'common/api'

import type { AppDispatch, RootState } from 'store'

export const getCurrentSeniorYear = () => api.get<number>(`/api/current-senior-year`)

const slice = createSlice({
  name: 'currentSeniorYear',
  initialState: 0,
  reducers: {
    setCurrentSeniorYear: (_, action: PayloadAction<number>) => action.payload,
  },
})

export const selectCurrentSeniorYear = (state: RootState): number => state.currentSeniorYear
export const { setCurrentSeniorYear } = slice.actions

export const fetchCurrentSeniorYear = () => (dispatch: AppDispatch) =>
  getCurrentSeniorYear()
    .then((seniorYear) => dispatch(setCurrentSeniorYear(seniorYear)))
    .catch(() => undefined)

export default slice.reducer
